<div class="banner d-none d-lg-flex" role="banner">
  <div class="container">
    <div class="title-wrapper">
      <img src="assets/images/banners/Welcome.png" alt="" />
    </div>
  </div>
</div>
<fgb-mobile-header-bar [title]="'account.page.title' | translate" [showPoints]="false"></fgb-mobile-header-bar>

<ng-container *ifScreenSize="screenType.Mobile">
  <div class="bg-primary member-card-container">
    <div class="container">
      <fgb-member-card showSeating="true"></fgb-member-card>
    </div>
  </div>
</ng-container>
<div class="mobile-content-wrapper">
  <div class="container pt-lg-4">
    <div class="row">
      <div class="col-12 col-lg-6 order-lg-2 order-2">
        <h3 class="mt-0 mb-2">{{ 'account.details.title' | translate }}</h3>
        <fgb-account-details></fgb-account-details>
      </div>
      <div class="col-12 col-lg-6 order-lg-1 order-1 d-none d-lg-block">
        <ng-container *ifScreenSize="screenType.Desktop">
          <h3 class="mb-2 mt-lg-0">{{ 'account.member.card.title' | translate }}</h3>
        </ng-container>
        <fgb-member-card showSeating="true"></fgb-member-card>
      </div>
    </div>
  </div>
</div>
